import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
// Styles
import './Image.css';

const NAME = 'image';

const Image = ({
    src,
    classOverride,
    name,
    fluid,
    rounded,
    thumbnail,
    bkgColor,
    type,
    children,
    position,
    width,
    height,
    enableRoundedCorners
}) => {
    const shape = rounded ? `${NAME}-rounded` : `${NAME}-square`;
    const cover = fluid ? `${NAME}-fluid` : '${NAME}-padding';
    const thumb = thumbnail ? `${NAME}-thumbnail` : '';
    const xsPosition = position && position.xs ? `${NAME}-position-xs-${position.xs}` : '';
    const mdPosition = position && position.md ? `${NAME}-position-md-${position.md}` : '';
    const lgPosition = position && position.lg ? `${NAME}-position-lg-${position.lg}` : '';

    const sizeStyle = width ? {'width': width, 'height': height} : {};
    
    return (
        <Fragment>
            {type === 'img' && (
                <img
                    style={sizeStyle}
                    className={`${NAME} ${classOverride} ${shape} ${cover} ${thumb} ${enableRoundedCorners ? 'sg-rc-bd-radius-top' : ''}`}
                    src={src}
                    alt={name}
                />
            )}
            {type === 'bkg' && (
                <div
                    style={`background-image:url("${src}"); backgound-color: ${bkgColor}`}
                    className={`${NAME} ${classOverride} ${NAME}-${type} ${NAME}-fluid ${xsPosition} ${mdPosition} ${lgPosition}`}
                    src={src}
                    alt={name}
                >
                    {children}
                </div>
            )}
        </Fragment>
    )
}

Image.defaultProps = {
    classOverride: '',
    name: 'Image',
    fluid: true,
    rounded: false,
    thumbnail: false,
    bkgColor: 'transparent',
    type: 'img' ,
    children: null,
    position: null,
    width: null,
    height: 'auto'
};

Image.propTypes = {
    // Image URL
    src: PropTypes.string.isRequired,
    // Image name for alt
    name: PropTypes.string,
    // Custom class
    classOverride: PropTypes.string,
    // Cover the parent container
    fluid: PropTypes.bool,
    // Circle image
    rounded: PropTypes.bool,
    // thumbnail
    thumbnail: PropTypes.bool,
    // A bkg Color
    bkgColor: PropTypes.string,
    // Image type or backaground image type 
    type: PropTypes.oneOf(['img', 'bkg']),
    // Backgound image content
    children: PropTypes.elementType,
    // Defined buy breakpoint could be
    // center left-top, left-center
    position: PropTypes.object,
    // Width and Height of image
    width: PropTypes.string,
    height: PropTypes.string
};
export default Image;
